module.exports = __webpack_public_path__ + "static/media/espiga_mix_preparada.0e173018.png";